function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-lines */
/* eslint-disable max-statements */
import React, { useEffect, useRef, useState } from 'react';

import {

  useLoaderData,
  useLocation,
  useNavigate,
  useRevalidator,
  useSearchParams } from
'react-router';

import { useSetAtom } from 'jotai';
import * as extractorsAPI from "../../../api/ix/extractors";
import * as suggestionsAPI from "../../../api/ix/suggestions";
import * as templatesAPI from "../../../api/templates";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Button, PaginationState, Paginator, Table } from "../../../Components/UI";
import { notificationAtom } from "../../../atoms";
import { Translate } from "../../../../I18N";

import { FunnelIcon } from '@heroicons/react/24/solid';
import { SuggestionsTitle } from "./components/SuggestionsTitle";
import { FiltersSidepanel } from "./components/FiltersSidepanel";
import { suggestionsTableColumnsBuilder } from "./components/TableElements";
import { generateChildrenRows, formatAccepted, updateSortingUrl } from "./helpers";
import {



  ixStatus } from "./types";



import { useEventHandler } from "./hooks/useEventHandler";
import { acceptedSuggestions } from "./components/atoms";
import { PDFSidepanel } from "./components/PDFSidepanel";
import { PropertySidepanel } from "./components/PropertySidepanel";

const SUGGESTIONS_PER_PAGE = 100;

const ixmessages = {
  ready: 'Find suggestions',
  sending_labeled_data: 'Sending labeled data...',
  processing_model: 'Training model...',
  processing_suggestions: 'Finding suggestions...',
  cancel: 'Canceling...',
  error: 'Error'
};

const IXSuggestions = () => {
  const {
    suggestions,
    extractor,
    templates,
    aggregation,
    currentStatus,
    totalPages,
    total,
    activeFilters
  } = useLoaderData();
  const prevSuggestions = useRef(suggestions);
  const keepRowOrder = useRef(true);
  const [currentSuggestions, setCurrentSuggestions] = useState(suggestions);
  const [property, setProperty] = useState();
  const [sidepanel, setSidepanel] = useState('none');
  const [status, setStatus] = useState(



    { status: currentStatus });
  const [selected, setSelected] = useState([]);
  const [sorting, setSorting] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [sidepanelSuggestion, setSidepanelSuggestion] = useState();
  const { revalidate } = useRevalidator();
  const setNotifications = useSetAtom(notificationAtom);
  const setAcceptedSuggestionsAtom = useSetAtom(acceptedSuggestions);

  const filteredTemplates = () =>
  templates ? templates.filter((template) => extractor.templates.includes(template._id)) : [];

  const onEntitySave = async () => {
    keepRowOrder.current = true;
    await revalidate();
  };

  const acceptSuggestions = async (suggestionsToAccept) => {
    const preparedSuggestions = formatAccepted(suggestionsToAccept);

    try {
      keepRowOrder.current = true;
      await suggestionsAPI.accept(preparedSuggestions);
      const newAcceptedIds = suggestionsToAccept.map((s) => s._id);
      setAcceptedSuggestionsAtom((prev) => {
        const newSet = new Set(prev || []);
        newAcceptedIds.forEach((id) => newSet.add(id));
        return newSet;
      });

      setSelected([]);
      setNotifications({
        type: 'info',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Suggestions sent")
      });
    } catch (error) {var _error$json;
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: (_error$json = error.json) !== null && _error$json !== void 0 && _error$json.prettyMessage ? error.json.prettyMessage : undefined
      });
    }
  };

  const findSuggestions = async (suggestionsToFind) => {
    try {
      await suggestionsAPI.findSelectedSuggestions(extractor._id, [
      ...new Set(suggestionsToFind.map((s) => s.sharedId))]
      );
      await revalidate();
      if (status.status === ixStatus.ready) {
        setStatus({
          status: ixStatus.processing_suggestions,
          message: ixmessages[ixStatus.processing_suggestions],
          data: { processed: 0, total: suggestionsToFind.length }
        });
      }
      if (status.status === ixStatus.processing_suggestions) {var _status$data, _status$data2;
        setStatus({
          status: ixStatus.processing_suggestions,
          message: ixmessages[ixStatus.processing_suggestions],
          data: {
            processed: ((_status$data = status.data) === null || _status$data === void 0 ? void 0 : _status$data.processed) || 0,
            total: (((_status$data2 = status.data) === null || _status$data2 === void 0 ? void 0 : _status$data2.total) || 0) + suggestionsToFind.length
          }
        });
      }
    } catch (error) {var _error$json2;
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: (_error$json2 = error.json) !== null && _error$json2 !== void 0 && _error$json2.prettyMessage ? error.json.prettyMessage : undefined
      });
    }
  };

  const trainModelOrCancelAction = async () => {
    try {
      keepRowOrder.current = false;
      if (status.status === ixStatus.ready) {
        await suggestionsAPI.findSuggestions(extractor._id);
        setStatus({ status: ixStatus.sending_labeled_data });
      } else {
        await suggestionsAPI.cancel(extractor._id);
        if (status.status === ixStatus.error) {
          setStatus({ status: ixStatus.ready });
        } else {
          setStatus({ status: ixStatus.cancel });
        }
        await revalidate();
        setAcceptedSuggestionsAtom(new Set());
      }
    } catch (error) {}
  };

  const testRun = async () => {
    try {
      setStatus({ status: ixStatus.sending_labeled_data });
      await suggestionsAPI.testRun(extractor._id);
    } catch (error) {}
  };

  const openSidepanel = (selectedSuggestion) => {
    setSidepanelSuggestion(selectedSuggestion);
    const type = selectedSuggestion.extractorSource.pdf ? 'pdf' : 'property';
    setSidepanel(type);
  };

  const closeSidepanel = () => {
    setSidepanelSuggestion(undefined);
    setSidepanel('none');
  };

  useEffect(() => {
    keepRowOrder.current = false;
    const navigatePromise = async (path) => navigate(path, { replace: true });
    const newUrl = updateSortingUrl(sorting, location.pathname, searchParams);
    navigatePromise(newUrl).catch((_e) => {});
  }, [sorting, searchParams]);

  useEffect(() => {var _template$commonPrope, _template$properties;
    const template = templates.find((t) => t._id === extractor.templates[0]);
    const _property =
    extractor.property === 'title' ?
    template === null || template === void 0 ? void 0 : (_template$commonPrope = template.commonProperties) === null || _template$commonPrope === void 0 ? void 0 : _template$commonPrope.find((prop) => prop.name === extractor.property) :
    template === null || template === void 0 ? void 0 : (_template$properties = template.properties) === null || _template$properties === void 0 ? void 0 : _template$properties.find((prop) => prop.name === extractor.property);
    setProperty(_property);
  }, [templates, extractor]);

  useEffect(() => {
    let newSuggestions = suggestions;

    if (keepRowOrder.current) {
      newSuggestions = prevSuggestions.current.map((currentSuggestion) => {
        const updatedSuggestion = suggestions.find(
          (newSuggestion) => newSuggestion._id === currentSuggestion._id
        );
        return updatedSuggestion || currentSuggestion;
      });
    }

    if ((property === null || property === void 0 ? void 0 : property.type) === 'multiselect' || (property === null || property === void 0 ? void 0 : property.type) === 'relationship') {
      setCurrentSuggestions(() =>
      newSuggestions.map((suggestion) => generateChildrenRows(suggestion))
      );
    } else {
      setCurrentSuggestions(
        newSuggestions.map(
          (suggestion) => _objectSpread(_objectSpread({}, suggestion), {}, { isChild: false })
        )
      );
    }

    prevSuggestions.current = newSuggestions;
  }, [suggestions, property, extractor]);

  useEffect(() => () => setAcceptedSuggestionsAtom(new Set()), [setAcceptedSuggestionsAtom]);

  useEventHandler({
    extractorId: extractor._id,
    updateStatus: (newStatus, data) => setStatus({ status: newStatus, data })
  });

  return (/*#__PURE__*/
    _jsx("div", { className: "h-full w-full overflow-y-auto", "data-testid": "settings-ix" }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, {
      path: new Map([['Metadata extraction', '/settings/metadata_extraction']]),
      title: extractor.name }
    ), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Table, {
      data: currentSuggestions,
      enableSelections: true,
      columns: suggestionsTableColumnsBuilder(
        filteredTemplates(),
        acceptSuggestions,
        openSidepanel
      ),
      sortingFn: (sortingState) => {
        setSorting(sortingState);
      },
      onChange: ({ selectedRows }) => {
        setSelected(() =>
        currentSuggestions.filter((current) => current.rowId in selectedRows)
        );
      },
      header: /*#__PURE__*/
      _jsx(SuggestionsTitle, { property: extractor.property, templates: filteredTemplates() }),

      actions: /*#__PURE__*/
      _jsx(Button, { size: "small", styling: "light", onClick: () => setSidepanel('filters') }, void 0, /*#__PURE__*/
      _jsx(FunnelIcon, {
        className: `inline w-4 mr-2 ${activeFilters > 0 ? 'text-primary-900' : 'text-gray-800'} ` }
      ), /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Stats & Filters"),
      activeFilters > 0 && /*#__PURE__*/
      _jsx("span", { className: "px-3 py-[2px] ml-2 text-xs text-white rounded-md bg-primary-900" }, void 0,
      activeFilters
      )

      ),

      footer: /*#__PURE__*/
      _jsx("div", { className: "flex justify-between h-6" }, void 0, /*#__PURE__*/
      _jsx(PaginationState, {
        page: Number(searchParams.get('page') || 1),
        size: SUGGESTIONS_PER_PAGE,
        total: total,
        currentLength: currentSuggestions.length }
      ), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Paginator, {
        totalPages: totalPages,
        currentPage: searchParams.has('page') ? Number(searchParams.get('page')) : 1,
        buildUrl: (page) => {
          const innerSearchParams = new URLSearchParams(location.search);
          innerSearchParams.delete('page');
          innerSearchParams.set('page', page);
          return `${location.pathname}?${innerSearchParams.toString()}`;
        } }
      )
      )
      ) }

    )
    ), /*#__PURE__*/

    _jsx(SettingsContent.Footer, { className: "flex gap-2", highlighted: selected.length > 0 }, void 0,
    selected.length ? /*#__PURE__*/
    _jsx("div", { className: "flex items-center justify-center space-x-4" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      size: "small",
      type: "button",
      styling: "outline",
      disabled:
      status.status === ixStatus.sending_labeled_data ||
      status.status === ixStatus.processing_model,

      onClick: async () => {
        await findSuggestions(selected);
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Find suggestions")
    ), /*#__PURE__*/
    _jsx(Button, {
      size: "small",
      type: "button",
      styling: "outline",
      disabled: selected.some(
        (s) => s.state.obsolete || s.state.error || s.state.processing
      ),
      onClick: async () => {
        await acceptSuggestions(selected);
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Accept suggestions")
    ), /*#__PURE__*/
    _jsx("div", { className: "text-sm font-semibold text-center text-gray-900" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "font-light text-gray-500" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected")
    ), "\xA0",

    selected.length, "\xA0", /*#__PURE__*/

    _jsx("span", { className: "font-light text-gray-500" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "of")
    ), "\xA0",

    SUGGESTIONS_PER_PAGE
    )
    ) : /*#__PURE__*/

    _jsx("div", { className: "flex items-center justify-center space-x-4" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      size: "small",
      type: "button",
      disabled: status.status === ixStatus.cancel,
      styling: status.status === ixStatus.ready ? 'solid' : 'outline',
      onClick: trainModelOrCancelAction }, void 0,

    status.status === ixStatus.ready ? /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Find suggestions") : /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")

    ),
    status.status === ixStatus.ready && /*#__PURE__*/
    _jsx(Button, { size: "small", type: "button", styling: "light", onClick: testRun }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Test run")
    ),

    status.status !== ixStatus.ready ? /*#__PURE__*/
    _jsx("div", { className: "text-sm font-semibold text-center text-gray-900" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, ixmessages[status.status]),
    status.message && status.status === ixStatus.error ? ` : ${status.message}` : '',
    status.data ? /*#__PURE__*/
    _jsx("span", { className: "ml-2" }, void 0,
    status.data.processed, " / ", status.data.total
    ) :
    null
    ) :
    null
    )

    )
    ), /*#__PURE__*/

    _jsx(FiltersSidepanel, {
      showSidepanel: sidepanel === 'filters',
      setShowSidepanel: closeSidepanel,
      aggregation: aggregation }
    ), /*#__PURE__*/

    _jsx(PropertySidepanel, {
      showSidepanel: sidepanel === 'property',
      property: property,
      setShowSidepanel: closeSidepanel,
      suggestion: sidepanelSuggestion,
      onEntitySave: onEntitySave }
    ), /*#__PURE__*/

    _jsx(PDFSidepanel, {
      showSidepanel: sidepanel === 'pdf',
      property: property,
      setShowSidepanel: closeSidepanel,
      suggestion: sidepanelSuggestion,
      onEntitySave: onEntitySave }
    )
    ));

};

const IXSuggestionsLoader =
(headers) =>
async ({ params: { extractorId }, request }) => {
  if (!extractorId) throw new Error('extractorId is required');
  const searchParams = new URLSearchParams(request.url.split('?')[1]);
  const filter = { extractorId };
  let activeFilters = 0;
  if (searchParams.has('filter')) {
    filter.customFilter = JSON.parse(searchParams.get('filter'));
    activeFilters = Object.values(filter.customFilter).filter(Boolean).length;
  }
  const sortingOption = searchParams.has('sort') ? searchParams.get('sort') : undefined;

  const suggestionsList =



  await suggestionsAPI.get(_objectSpread({

    filter,
    page: {
      number: searchParams.has('page') ? Number(searchParams.get('page')) : 1,
      size: SUGGESTIONS_PER_PAGE
    } },
  sortingOption && { sort: JSON.parse(sortingOption) }),

  headers
  );

  const extractors = await extractorsAPI.getById(extractorId, headers);
  const aggregation = await suggestionsAPI.aggregation(extractorId, headers);
  const currentStatus = await suggestionsAPI.status(extractorId, headers);
  const templates = await templatesAPI.get(headers);
  const suggestions = suggestionsList.suggestions.map((suggestion) => _objectSpread(_objectSpread({},
  suggestion), {}, {
    rowId: suggestion._id,
    disableRowSelection: suggestion.state.processing,
    extractorSource: extractors[0].source })
  );

  return {
    suggestions,
    totalPages: suggestionsList.totalPages,
    extractor: extractors[0],
    templates,
    aggregation,
    currentStatus: currentStatus.status,
    activeFilters,
    total: suggestionsList.total
  };
};

export { IXSuggestions, IXSuggestionsLoader };